/**
 * Gigya Screen Sets render a single `.gigya-label-text` node. Toggling 400↔700 for hover/focus
 * shifts layout. We wrap the label in a stack: invisible bold copy (size) + visible text (z-index),
 * matching the floating label pattern.
 */
export function installGigyaFloatingLabelTextStacks(root: ParentNode = document): void {
  const screenset = root.querySelector('#screenset');
  if (!screenset) {
    return;
  }

  const labelTexts = screenset.querySelectorAll<HTMLSpanElement>('span.gigya-label-text:not([data-swd-label-stack])');

  for (const labelText of labelTexts) {
    const composite = labelText.closest('.gigya-composite-control');
    if (
      !composite ||
      composite.classList.contains('gigya-composite-control-checkbox') ||
      composite.classList.contains('gigya-composite-control-submit') ||
      composite.classList.contains('gigya-composite-control-social-login') ||
      composite.classList.contains('gigya-composite-control-header')
    ) {
      continue;
    }

    const parent = labelText.parentElement;
    if (!parent?.classList.contains('gigya-label')) {
      continue;
    }

    const stack = document.createElement('span');
    stack.className = 'gigya-label-text-stack';
    stack.setAttribute('data-swd-label-stack', '');

    const shadow = document.createElement('span');
    shadow.className = 'gigya-label-text-shadow';
    shadow.setAttribute('aria-hidden', 'true');
    shadow.textContent = labelText.textContent ?? '';

    parent.insertBefore(stack, labelText);
    stack.appendChild(shadow);
    stack.appendChild(labelText);
    labelText.setAttribute('data-swd-label-stack', '');
  }
}
